import {createContext} from 'react';

export type ExternalLinksContextType = {
    platformLink: string,
};

export const ExternalLinksContext = createContext<ExternalLinksContextType>({
    platformLink: '',
});
